export const salesPersonRoute = {
  base: '/sales-person',
  jobs: '/jobs',
  crm: '/crm',
  leads: '/leads',
  clients: '/clients',
  communication: '/communication',
  quotes: '/quotes',
  inventory: '/inventory',
  product: '/product',
  package: '/package',
  settings: '/settings',
  users: '/users',
  schedule: '/schedule',
  vehicles: '/vehicles',
  trucks: '/trucks',
  equipments: '/equipments',
  trailers: '/trailers',
  vendors: '/vendors',
  purchaseOrder: '/purchase-order',
  order: '/order',
  roleManagement: '/role-management',
  coupon: '/coupon',
  eventType: '/event-type',
  category: '/category',
  quarantines: '/quarantine',
  invoice: '/invoice',
  checklist: '/checklist',
  task: '/task',
  global: '/global',
  venue: '/venue',

  // Reports
  reports: '/reports',
  overbookingItem: '/overbooking-item',
  subrentalsReport: '/subrentals',
  quarantineReport: '/quarantine',
  foremanTaskReport: '/foreman-task-completion',
  clientIncomeReport: '/client-income',
  revenueReport: '/revenue',
  geographicRevenueReport: '/geographic-revenue',
  quoteRevenueReport: '/quote-revenue',
  orderRevenueReport: '/order-revenue',
  cancellationReport: '/cancellation',
  deliveryReport: '/delivery-pickup',
  taskCompletionReport: '/task-completion',
  discountUsageReport: '/discount-usage',
  featureUtilizationReport: '/feature-utilization',
  jobCostingReport: '/job-costing',
  inventoryUsageReport: '/inventory-usage',
  marketingRevenueReport: '/marketing-revenue',
  financialOrderReport: '/financial-order',
  transactionSummaryReport: '/transaction-summary',

  // Common
  commonCreate: '/create',
  commonEdit: '/edit',
  commonClone: '/clone',
  commonDetail: '/:id',
};

export const salesPersonRouteVehicles = {
  vehicles: `${salesPersonRoute.base}${salesPersonRoute.vehicles}`,
};

export const salesPersonRouteTrucks = {
  trucks: `${salesPersonRoute.base}${salesPersonRoute.vehicles}${salesPersonRoute.trucks}`,
};

export const salesPersonRouteEquipments = {
  equipments: `${salesPersonRoute.base}${salesPersonRoute.vehicles}${salesPersonRoute.equipments}`,
};

export const salesPersonRouteTrailers = {
  trailers: `${salesPersonRoute.base}${salesPersonRoute.vehicles}${salesPersonRoute.trailers}`,
};

export const salesPersonRouteVendors = {
  vendors: `${salesPersonRoute.base}${salesPersonRoute.vendors}`,
  detailVendor: `${salesPersonRoute.base}${salesPersonRoute.vendors}${salesPersonRoute.commonDetail}`,
};

export const salesPersonRoutePurchaseOrder = {
  purchaseOrder: `${salesPersonRoute.base}${salesPersonRoute.purchaseOrder}`,
  detailPurchaseOrder: (purchaseOrderId: string) =>
    `${salesPersonRoute.base}${salesPersonRoute.purchaseOrder}/${purchaseOrderId}`,
};

export const salesPersonRouteOrder = {
  order: `${salesPersonRoute.base}${salesPersonRoute.order}`,
  detailOrder: (orderId: string) => `${salesPersonRoute.base}${salesPersonRoute.order}/${orderId}`,
  updateOrder: (orderId: string) =>
    `${salesPersonRoute.base}${salesPersonRoute.order}/${orderId}${salesPersonRoute.commonEdit}`,
};

export const salesPersonRouteCrm = {
  crm: `${salesPersonRoute.base}${salesPersonRoute.crm}`,
  leads: `${salesPersonRoute.base}${salesPersonRoute.crm}${salesPersonRoute.leads}`,
  createLead: `${salesPersonRoute.base}${salesPersonRoute.crm}${salesPersonRoute.leads}${salesPersonRoute.commonCreate}`,
  detailLead: (leadId: string) => `${salesPersonRoute.base}${salesPersonRoute.crm}${salesPersonRoute.leads}/${leadId}`,
  updateLead: (leadId: string) =>
    `${salesPersonRoute.base}${salesPersonRoute.crm}${salesPersonRoute.leads}/${leadId}${salesPersonRoute.commonEdit}`,
  clients: `${salesPersonRoute.base}${salesPersonRoute.crm}${salesPersonRoute.clients}`,
  createClient: `${salesPersonRoute.base}${salesPersonRoute.crm}${salesPersonRoute.clients}${salesPersonRoute.commonCreate}`,
  detailClient: (clientId: string) =>
    `${salesPersonRoute.base}${salesPersonRoute.crm}${salesPersonRoute.clients}/${clientId}`,
  updateClient: (clientId: string) =>
    `${salesPersonRoute.base}${salesPersonRoute.crm}${salesPersonRoute.clients}/${clientId}${salesPersonRoute.commonEdit}`,
};

export const salesPersonRouteQuote = {
  quotes: `${salesPersonRoute.base}${salesPersonRoute.quotes}`,
  createQuotes: `${salesPersonRoute.base}${salesPersonRoute.quotes}${salesPersonRoute.commonCreate}`,
  detailQuote: (quoteId: string) => `${salesPersonRoute.base}${salesPersonRoute.quotes}/${quoteId}`,
  updateQuote: (quoteId: string) =>
    `${salesPersonRoute.base}${salesPersonRoute.quotes}/${quoteId}${salesPersonRoute.commonEdit}`,
};

export const salesPersonRouteInventory = {
  inventories: `${salesPersonRoute.base}${salesPersonRoute.inventory}`,
  inventory: `${salesPersonRoute.base}${salesPersonRoute.inventory}${salesPersonRoute.product}`,
  createInventory: `${salesPersonRoute.base}${salesPersonRoute.inventory}${salesPersonRoute.product}${salesPersonRoute.commonCreate}`,
  detailInventory: (inventoryId: string) =>
    `${salesPersonRoute.base}${salesPersonRoute.inventory}${salesPersonRoute.product}/${inventoryId}`,
  updateInventory: (inventoryId: string) =>
    `${salesPersonRoute.base}${salesPersonRoute.inventory}${salesPersonRoute.product}/${inventoryId}${salesPersonRoute.commonEdit}`,
};

export const salesPersonRoutePackage = {
  package: `${salesPersonRoute.base}${salesPersonRoute.inventory}${salesPersonRoute.package}`,
  createPackage: `${salesPersonRoute.base}${salesPersonRoute.inventory}${salesPersonRoute.package}${salesPersonRoute.commonCreate}`,
  updatePackage: (packageId: string) =>
    `${salesPersonRoute.base}${salesPersonRoute.inventory}${salesPersonRoute.package}/${packageId}${salesPersonRoute.commonEdit}`,
  clonePackage: (packageId: string) =>
    `${salesPersonRoute.base}${salesPersonRoute.inventory}${salesPersonRoute.package}/${packageId}${salesPersonRoute.commonClone}`,
};

export const salesPersonRouteUser = {
  users: `${salesPersonRoute.base}${salesPersonRoute.settings}${salesPersonRoute.users}`,
  createUser: `${salesPersonRoute.base}${salesPersonRoute.settings}${salesPersonRoute.users}${salesPersonRoute.commonCreate}`,
  detailUser: (userId: string) =>
    `${salesPersonRoute.base}${salesPersonRoute.settings}${salesPersonRoute.users}/${userId}`,
  updateUser: (userId: string) =>
    `${salesPersonRoute.base}${salesPersonRoute.settings}${salesPersonRoute.users}/${userId}${salesPersonRoute.commonEdit}`,
};

export const salesPersonRouteVenue = {
  venue: `${salesPersonRoute.base}${salesPersonRoute.settings}${salesPersonRoute.venue}`,
  createVenue: `${salesPersonRoute.base}${salesPersonRoute.settings}${salesPersonRoute.venue}${salesPersonRoute.commonCreate}`,
  detailVenue: (venueId: string) =>
    `${salesPersonRoute.base}${salesPersonRoute.settings}${salesPersonRoute.venue}/${venueId}`,
  updateVenue: (venueId: string) =>
    `${salesPersonRoute.base}${salesPersonRoute.settings}${salesPersonRoute.venue}/${venueId}${salesPersonRoute.commonEdit}`,
};

export const salesPersonRouteInvoice = {
  invoices: `${salesPersonRoute.base}${salesPersonRoute.invoice}`,
  createInvoice: `${salesPersonRoute.base}${salesPersonRoute.invoice}${salesPersonRoute.commonCreate}`,
  updateInvoice: (invoiceId: string) =>
    `${salesPersonRoute.base}${salesPersonRoute.invoice}/${invoiceId}${salesPersonRoute.commonEdit}`,
};

export const salesPersonRouteRoleManagement = {
  roleManagement: `${salesPersonRoute.base}${salesPersonRoute.settings}${salesPersonRoute.roleManagement}`,
  createRole: `${salesPersonRoute.base}${salesPersonRoute.settings}${salesPersonRoute.roleManagement}${salesPersonRoute.commonCreate}`,
  updateRole: (roleId: string) =>
    `${salesPersonRoute.base}${salesPersonRoute.settings}${salesPersonRoute.roleManagement}/${roleId}${salesPersonRoute.commonEdit}`,
};

export const salesPersonRouteRoleCoupon = {
  coupon: `${salesPersonRoute.base}${salesPersonRoute.settings}${salesPersonRoute.coupon}`,
};

export const salesPersonRouteRoleEventType = {
  eventType: `${salesPersonRoute.base}${salesPersonRoute.settings}${salesPersonRoute.eventType}`,
};

export const salesPersonRouteRoleCategory = {
  category: `${salesPersonRoute.base}${salesPersonRoute.settings}${salesPersonRoute.category}`,
};

export const salesPersonRouteRoleChecklist = {
  checklist: `${salesPersonRoute.base}${salesPersonRoute.settings}${salesPersonRoute.checklist}`,
};

export const salesPersonRouteJob = {
  jobs: `${salesPersonRoute.base}${salesPersonRoute.jobs}`,
  detailJob: (jobId: string) => `${salesPersonRoute.base}${salesPersonRoute.jobs}/${jobId}`,
};

export const salesPersonRouteQuarantine = {
  quarantine: `${salesPersonRoute.base}${salesPersonRoute.inventory}${salesPersonRoute.quarantines}`,
};

export const salesPersonRouteTask = {
  task: `${salesPersonRoute.base}${salesPersonRoute.task}`,
};

export const salesPersonRouteGlobal = {
  global: `${salesPersonRoute.base}${salesPersonRoute.global}`,
};

export const salesPersonRouteReport = {
  reports: `${salesPersonRoute.base}${salesPersonRoute.reports}`,
  overbookingItem: `${salesPersonRoute.base}${salesPersonRoute.reports}${salesPersonRoute.overbookingItem}`,
  subrentalsReport: `${salesPersonRoute.base}${salesPersonRoute.reports}${salesPersonRoute.subrentalsReport}`,
  clientIncomeReport: `${salesPersonRoute.base}${salesPersonRoute.reports}${salesPersonRoute.clientIncomeReport}`,
  revenueReport: `${salesPersonRoute.base}${salesPersonRoute.reports}${salesPersonRoute.revenueReport}`,
  geographicRevenueReport: `${salesPersonRoute.base}${salesPersonRoute.reports}${salesPersonRoute.geographicRevenueReport}`,
  quoteRevenueReport: `${salesPersonRoute.base}${salesPersonRoute.reports}${salesPersonRoute.quoteRevenueReport}`,
  orderRevenueReport: `${salesPersonRoute.base}${salesPersonRoute.reports}${salesPersonRoute.orderRevenueReport}`,
  cancellationReport: `${salesPersonRoute.base}${salesPersonRoute.reports}${salesPersonRoute.cancellationReport}`,
  deliveryReport: `${salesPersonRoute.base}${salesPersonRoute.reports}${salesPersonRoute.deliveryReport}`,
  taskCompletionReport: `${salesPersonRoute.base}${salesPersonRoute.reports}${salesPersonRoute.taskCompletionReport}`,
  discountUsageReport: `${salesPersonRoute.base}${salesPersonRoute.reports}${salesPersonRoute.discountUsageReport}`,
  featureUtilizationReport: `${salesPersonRoute.base}${salesPersonRoute.reports}${salesPersonRoute.featureUtilizationReport}`,
  jobCostingReport: `${salesPersonRoute.base}${salesPersonRoute.reports}${salesPersonRoute.jobCostingReport}`,
  inventoryUsageReport: `${salesPersonRoute.base}${salesPersonRoute.reports}${salesPersonRoute.inventoryUsageReport}`,
  quarantineReport: `${salesPersonRoute.base}${salesPersonRoute.reports}${salesPersonRoute.quarantineReport}`,
  foremanTaskReport: `${salesPersonRoute.base}${salesPersonRoute.reports}${salesPersonRoute.foremanTaskReport}`,
  marketingRevenueReport: `${salesPersonRoute.base}${salesPersonRoute.reports}${salesPersonRoute.marketingRevenueReport}`,
  financialOrderReport: `${salesPersonRoute.base}${salesPersonRoute.reports}${salesPersonRoute.financialOrderReport}`,
  transactionSummaryReport: `${salesPersonRoute.base}${salesPersonRoute.reports}${salesPersonRoute.transactionSummaryReport}`,
};

export const salesPersonRouteAbsolute = {
  // Dashboard
  dashboard: salesPersonRoute.base,

  // Communication
  communication: `${salesPersonRoute.base}${salesPersonRoute.communication}`,

  // Settings
  settings: `${salesPersonRoute.base}${salesPersonRoute.settings}`,

  // Schedule
  schedule: `${salesPersonRoute.base}${salesPersonRoute.schedule}`,

  ...salesPersonRouteVehicles,
  ...salesPersonRouteTrucks,
  ...salesPersonRouteEquipments,
  ...salesPersonRouteTrailers,
  ...salesPersonRouteVendors,
  ...salesPersonRoutePurchaseOrder,
  ...salesPersonRouteOrder,
  ...salesPersonRouteCrm,
  ...salesPersonRouteQuote,
  ...salesPersonRouteInventory,
  ...salesPersonRoutePackage,
  ...salesPersonRouteUser,
  ...salesPersonRouteVenue,
  ...salesPersonRouteRoleManagement,
  ...salesPersonRouteRoleCoupon,
  ...salesPersonRouteRoleEventType,
  ...salesPersonRouteRoleCategory,
  ...salesPersonRouteRoleChecklist,
  ...salesPersonRouteJob,
  ...salesPersonRouteQuarantine,
  ...salesPersonRouteInvoice,
  ...salesPersonRouteReport,
  ...salesPersonRouteTask,
  ...salesPersonRouteGlobal,
};
